module.exports = function($) {
    class interactiveMap{
        constructor(){
            this.bind();
        }

        bind(){
            $('.interactive-map input[type="radio"]').on('change', function(){
              const value = $(this).val();
              if( value == 'all' ){
                  // $('.interactive-map .map-container .picto, .interactive-map .map-container .pin').css({'display':'block'});
                  $('.interactive-map .map-container .picto, .interactive-map .map-container .pin').removeClass('hide');
              } else {
                  // $('.interactive-map .map-container .picto, .interactive-map .map-container .pin').css({'display':'none'});
                  $('.interactive-map .map-container .picto, .interactive-map .map-container .pin').addClass('hide');
                  // $('.interactive-map .map-container .picto[data-id="'+value+'"], .interactive-map .map-container .pin[data-id="'+value+'"]').css({'display':'block'});
                  $('.interactive-map .map-container .picto[data-id="'+value+'"], .interactive-map .map-container .pin[data-id="'+value+'"]').removeClass('hide');
              }
            })
        }
    }

    new interactiveMap();
}


